export default function flattenTagValue(value) {
    if (Array.isArray(value))
        return value.map((v) => flattenTagValue(v));
    else if (typeof value === "object") {
        return Object.fromEntries(Object.entries(value).map(([key, v]) => {
            if (typeof v === "object" && "value" in v)
                return [key, flattenTagValue(v.value)];
            else
                return [key, flattenTagValue(v)];
        }));
    }
    else
        return value;
}
